import { post, get, del, put } from './requests'

export const getTodayItems = key => () => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone

  return post(
    ['api', 'todayItems', 'list'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId }
  )
}

export const setTodayItemsOrder = key => payload =>
  post(
    ['api', 'todayItems', 'order'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteTodayItem = key => id =>
  del(['api', 'todayItems', id], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const createTodayItem = key => payload => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
  return post(
    ['api', 'todayItems'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId, ...payload }
  )
}

export const updateTodayItem = key => (id, payload) => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone

  return put(
    ['api', 'todayItems', id],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId, ...payload }
  )
}

export const updateTodayItemStatus = key => (id, payload) =>
  put(
    ['api', 'todayItems', id, 'updateStatus'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const refLogEntry = key => (id, payload) =>
  put(
    ['api', 'todayItems', id, 'refLog'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateTodayItemDate = key => id =>
  put(['api', 'todayItems', id, 'updateDate'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const completeTodayItem = key => payload => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone

  return post(
    ['api', 'todayItems', 'complete-item'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId, ...payload }
  )
}

export const undoTodayItem = key =>
  post(['api', 'todayItems', 'undo'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })



// WEBPACK FOOTER //
// ./src/services/today-items.js